import Drugs from "./Drugs";

export default Drugs;
